<template>
  <div class="mask">
    <div class="container">
      <div class="container_l">
        <div class="img_content">
          <img
            :src="item.path"
            class="big_img"
            v-for="(item, index) in info.files"
            :key="index"
            :style="{ opacity: `${currentImg == index ? 1 : 0}` }"
          />
        </div>
        <div class="footer">
          <div class="footer_btn_l" @click="changeSlide('left')">←</div>
          <div class="footer_content" ref="footerContent">
            <img
              ref="imgItem"
              :class="index == currentImg ? 'img_active' : ''"
              v-lazy="item.path"
              :style="{ transform: `translateX(${translateX}px)` }"
              v-for="(item, index) in info.files"
              :key="index"
              @mousemove="changeCurrentImg(index)"
            />
          </div>
          <div class="footer_btn_r" @click="changeSlide('right')">→</div>
        </div>
      </div>
      <div class="container_r">
        <div class="title">{{ info.building_name || "--" }}</div>
        <div class="building_meta">
          <div v-if="floorText">{{ floorText }}</div>
          <div v-if="businessText">商圈：{{ businessText }}</div>
          <div v-if="subwayText">地铁：{{ subwayText }}</div>
          <div v-if="addressText">{{ addressText }}</div>
        </div>
        <div class="price">
          <template v-if="hasPrice">
            <span class="count">{{ displayPrice }}</span>
            <span class="unit">元/月</span>
          </template>
          <span v-else class="no_price">暂无</span>
        </div>
        <div class="tag">
          <div
            class="tag_item"
            v-for="(item, index) in buildingTags"
            :key="index"
          >
            {{ item }}
          </div>
        </div>
        <div class="subtitle" v-if="buildingDesc">楼栋描述</div>
        <div class="content" v-if="buildingDesc" :title="buildingDesc">
          {{ buildingDesc }}
        </div>
        <div class="btn_div yuyue">
          <img src="../../assets/image/dh.png" />
          电话预约：{{ bookingPhone }}
        </div>
        <div class="btn_div yuyue" v-if="false">
          预约看房
          <div style="position: relative">
            <div class="qr_code">
              <!-- <img
                :src="info.booking_advice_info?.qrcode?.src"
                :title="info.booking_advice_info?.qrcode?.title"
              /> -->
              <img src="@/assets/image/ewm.png" title="预约二维码" />
              <span>手机扫一扫上方二维码，预约看房</span>
            </div>
          </div>
        </div>
        <div
          v-if="
            info.config &&
            info.config.other_expenses &&
            info.config.other_expenses.length
          "
        >
          <div class="subtitle">费用信息</div>
          <div class="cost">
            <div
              v-for="(item, index) in info.config.other_expenses"
              :key="index"
            >
              {{ item.name }}：{{ item.value }}
              <span v-if="item.name == '管理费'">元</span>
              <span v-else-if="item.name == '水费'">元/吨</span>
              <span v-else-if="item.name == '电费'">元/度</span>
              <span v-else-if="item.name == '网络费'">元/月</span>
            </div>
          </div>
        </div>
        <template v-if="filesList && filesList.length">
          <div class="subtitle">房型配置</div>
          <div class="icon_list">
            <div
              class="icon_list_item"
              v-for="(item, index) in filesList"
              :key="index"
            >
              <img :src="item.value" />
              <span>{{ item.label }}</span>
            </div>
          </div>
        </template>
      </div>
      <div class="container_pro">
        <div class="container_pro_title">常见问题</div>
        <div class="container_pro_list" v-if="contentList.length">
          <div
            class="container_pro_item"
            v-for="(item, index) in contentList"
            :key="index"
          >
            <div class="container_pro_item_t">
              <img src="@/assets/image/wen@2x.png" alt="" />
              <span>{{ item.title }}</span>
            </div>
            <div class="container_pro_item_b">
              <img src="@/assets/image/da@2x.png" alt="" />
              <span>{{ item.content }}</span>
            </div>
          </div>
        </div>
        <div class="container_pro_empty" v-else>
          <div class="empty_icon">?</div>
          <div class="empty_title">暂无问题</div>
          <div class="empty_desc">该楼栋暂时没有常见问题内容</div>
        </div>
      </div>
      <!-- 关闭按钮 -->
      <img src="../../assets/image/gb.png" class="close" @click="closeDialog" />
    </div>
    <small-loading v-if="isLoading" />
  </div>
</template>
<script>
import smallLoading from "@/components/loading/smallLoading.vue";
import { getBuildingDetail, qaLists } from "@/api/lookHouse";
export default {
  components: {
    smallLoading,
  },
  props: {
    itemData: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      translateX: 0,
      current: 0,
      currentImg: 0,
      iconList: [
        { icon: "chuang", name: "床" },
        { icon: "rsq", name: "热水器" },
        { icon: "bx", name: "冰箱" },
        { icon: "xyj", name: "洗衣机" },
        { icon: "yyj", name: "油烟机" },
        { icon: "sf", name: "沙发" },
        { icon: "kt", name: "空调" },
        { icon: "yz", name: "餐椅" },
        { icon: "xg", name: "鞋柜" },
        { icon: "czg", name: "餐桌" },
        { icon: "yg", name: "衣柜" },
        { icon: "wbl", name: "微波炉" },
      ],
      info: {},
      filesList: [],
      isLoading: false,
      timer: {},
      contentList: [],
    };
  },
  mounted() {
    this.initPageData();
  },
  computed: {
    floorText() {
      const floor = this.info.floor_count;
      const room = this.info.room_count;
      if (floor) return `共${floor}层`;
      if (room) return `共${room}间`;
      return "";
    },
    businessText() {
      let sq = null;
      sq = (this.info?.dept?.business_areas || [])
        .map((item) => {
          return item.sq_name;
        })
        .join("，");
      return sq;
    },
    subwayText() {
      let dt = null;
      dt = (this.info?.dept?.stations || [])
        .map((item) => {
          return item.station_name;
        })
        .join("，");
      return dt;
    },
    addressText() {
      return this.info.address;
    },
    hasPrice() {
      const min = this.info.min_price;
      const max = this.info.max_price;
      return (
        min !== null &&
        min !== undefined &&
        min !== "" &&
        max !== null &&
        max !== undefined &&
        max !== ""
      );
    },
    displayPrice() {
      if (!this.hasPrice) return "暂无";
      return `${Number(this.info.min_price).toFixed(0)}-${Number(
        this.info.max_price
      ).toFixed(0)}`;
    },
    buildingTags() {
      return (this.info.labels || this.info.appliances || [])
        .map((item) => item.bq_name || item.name || item)
        .filter(Boolean);
    },
    buildingDesc() {
      return (
        this.info.brief_info ||
        this.info.description ||
        this.info.building_desc ||
        this.info.desc ||
        ""
      );
    },
    bookingPhone() {
      return (
        (this.info.booking_advice_info &&
          this.info.booking_advice_info.booking_line) ||
        this.info.booking_line ||
        "4001883001"
      );
    },
  },
  methods: {
    initPageData() {
      this.isLoading = true;
      Promise.all([this.initData(), this.initContent()]).finally((_) => {
        this.isLoading = false;
      });
    },
    initData() {
      return getBuildingDetail({ building_id: this.itemData.id }).then(
        (res) => {
          let iconList = [];
          this.iconList.forEach((item) => {
            (res.data.labels || []).forEach((item2) => {
              if (item.name == item2.bq_name) {
                iconList.push({
                  label: item2.bq_name,
                  value: item2.cover_host + item2.cover_path,
                });
              }
            });
          });
          this.filesList = iconList.slice(0, 12);
          this.info = res.data;
        }
      );
    },
    initContent() {
      let data = {
        building_id: this.itemData.id,
      };
      return qaLists(data).then((res) => {
        this.contentList = res.data || [];
      });
    },
    stop() {
      let mo = function (e) {
        e.preventDefault();
      };
      document.body.style.overflow = "hidden";
      document.addEventListener("touchmove", mo, false); //禁止页面滑动
    },
    move() {
      let mo = function (e) {
        e.preventDefault();
      };
      document.body.style.overflow = ""; //出现滚动条
      document.removeEventListener("touchmove", mo, false);
    },
    closeDialog() {
      this.$parent.isShow = false;
      this.$parent.showBuildDetail = false;
    },
    changeSlide(type) {
      let width = this.$refs.imgItem[0]?.offsetWidth || 0;
      let border = "";
      if (this.$refs.footerContent) {
        border = window
          .getComputedStyle(this.$refs.footerContent)
          .columnGap.split("px")[0];
      }
      //元素移动的距离
      let distance = width + Number(border);
      this.executeAnimation();
      if (type == "left") {
        if (this.currentImg == 0) {
          this.currentImg = this.info?.files?.length - 1;
          this.translateX = (this.info?.files?.length - 4) * distance * -1;
        } else {
          this.currentImg = this.currentImg - 1;
          if (this.currentImg > 2) {
            this.translateX = this.translateX + distance;
          }
        }
      } else if (type == "right") {
        if (this.currentImg == this.info?.files?.length - 1) {
          this.currentImg = 0;
        } else {
          this.currentImg = this.currentImg + 1;
        }
        //滑动
        if (this.currentImg > 3) {
          this.translateX = this.translateX - distance;
        } else {
          this.translateX = 0;
        }
      }
    },
    changeCurrentImg(i) {
      this.currentImg = i;
    },
    executeAnimation() {
      clearInterval(this.timer);
      this.timer = setInterval(() => {
        this.changeSlide("right");
      }, 3000);
    },
  },
};
</script>
<style scoped lang="scss">
.img_active {
  border: 2px solid #ffa71d;
  box-sizing: border-box;
}
.mask {
  position: fixed;
  inset: 0;
  z-index: 999;
  width: 100vw;
  height: 100vh;
  background-color: rgba($color: #000000, $alpha: 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  .container {
    width: 1400px;
    height: 632px;
    padding: 20px;
    box-sizing: border-box;
    background-color: #fff;
    position: relative;
    display: flex;
    column-gap: 20px;
    .close {
      width: 50px;
      height: 50px;
      position: absolute;
      top: -54px;
      right: -54px;
      cursor: pointer;
    }
    &_l {
      width: 667px;
      height: 100%;
      display: flex;
      flex-direction: column;
      row-gap: 18px;
      .img_content {
        width: 100%;
        height: 472px;
        overflow: hidden;
        position: relative;
        .big_img {
          width: 100%;
          height: 100% !important;
          object-fit: cover;
          position: absolute;
          inset: 0;
          transition: all 1s ease;
        }
      }
      .footer {
        display: flex;
        column-gap: 20px;
        &_content {
          flex: 1;
          overflow: hidden;
          display: flex;
          column-gap: 19px;
          img {
            min-width: 125px;
            max-width: 125px;
            height: 100px;
            object-fit: cover;
            cursor: pointer;
            transition: all 0.3s ease;
          }
        }
        &_btn_l,
        &_btn_r {
          width: 35px;
          height: 100px;
          background: #ffa71d;
          color: #fff;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          -webkit-user-select: none; /* Safari */
          -moz-user-select: none; /* Firefox */
          -ms-user-select: none; /* IE 10+/Edge */
          user-select: none;
        }
      }
    }
    &_r {
      width: 333px;
      height: 100%;
      color: #333333;
      .title {
        font-size: 22px;
        font-weight: bold;
        line-height: 30px;
      }
      .subtitle {
        font-size: 18px;
        font-weight: bold;
        margin-top: 14px;
      }
      .building_meta {
        color: #666666;
        font-size: 13px;
        line-height: 24px;
        margin: 4px 0 6px;
      }
      .square {
        color: #666666;
        font-size: 14px;
        margin: 10px 0;
        display: flex;
        column-gap: 10px;
        align-items: center;
      }
      .price {
        min-height: 30px;
        .count {
          color: #ff4d4d;
          font-size: 22px;
          font-weight: bold;
        }
        .unit {
          font-size: 14px;
        }
        .no_price {
          color: #999999;
          font-size: 18px;
          font-weight: bold;
        }
      }
      .tag {
        display: flex;
        column-gap: 10px;
        flex-wrap: wrap;
        row-gap: 5px;
        margin-top: 5px;
        margin-bottom: 10px;
        &_item {
          padding: 3px 5px;
          box-sizing: border-box;
          background: #f4f4f4;
          border: 1px solid #d9d9d9;
          border-radius: 4px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 12px;
          flex-shrink: 0;
        }
      }
      .content {
        font-size: 12px;
        text-indent: 2em;
        line-height: 20px;
        margin: 10px 0;

        display: -webkit-box;
        -webkit-line-clamp: 4;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .btn_div {
        width: 100%;
        height: 40px;
        background: #999999;
        color: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 14px;
        column-gap: 10px;
        border-radius: 4px;
        margin: 10px 0;
        position: relative;
        img {
          width: 18px;
          height: 18px;
        }
        .qr_code {
          width: 250px;
          height: 250px;
          padding: 20px 20px 34px 20px;
          box-sizing: border-box;
          background-color: #fff;
          position: absolute;
          bottom: 42px;
          left: 50%;
          z-index: 9999999;
          display: none;
          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
          span {
            font-size: 14px;
            color: #666666;
            display: block;
            white-space: nowrap; /* 防止文本换行 */
            overflow: hidden; /* 溢出部分隐藏 */
            text-overflow: ellipsis; /* 超出部分显示省略号 */
          }
          &::after {
            content: "";
            display: block;
            width: 0;
            height: 0;
            border-top: 10px solid #fff;
            border-bottom: 14px solid transparent;
            border-right: 10px solid transparent;
            border-left: 10px solid transparent;
            position: absolute;
            bottom: -22px;
            left: 10%;
          }
        }
      }
      .yuyue {
        background: #ffa71d;

        &:hover {
          .qr_code {
            display: block;
          }
        }
      }
      .cost {
        display: grid;
        grid-template-columns: 1fr 1fr;
        grid-template-rows: 1fr 1fr;
        grid-gap: 10px;
        font-size: 12px;
        color: #666;
        margin: 10px 0;
      }
      .icon_list {
        display: grid;
        grid-template-columns: repeat(4, 1fr);
        grid-gap: 20px;
        color: #666;
        margin-top: 10px;
        &_item {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          font-size: 12px;
          img {
            width: 30px;
            height: 30px;
          }
        }
      }
    }
    &_pro {
      flex: 1;
      height: 100%;
      border-left: 1px solid #eee;
      padding: 0 0 0 20px;
      box-sizing: border-box;
      display: flex;
      flex-direction: column;
      &_title {
        font-size: 18px;
        font-weight: bold;
        color: #333333;
        margin-bottom: 16px;
      }
      &_list {
        flex: 1;
        display: flex;
        flex-direction: column;
        overflow: scroll;
        -ms-overflow-style: none;
        scrollbar-width: none;
        &::-webkit-scrollbar {
          display: none;
        }
      }
      &_item {
        width: 100%;
        background: #f5f5f5;
        border-radius: 4px;
        padding: 16px;
        box-sizing: border-box;
        margin-bottom: 10px;
        img {
          width: 20px;
          height: 20px;
        }
        &_t {
          display: flex;
          align-items: center;
          column-gap: 10px;
          margin-bottom: 15px;
          span {
            font-size: 18px;
            font-weight: bold;
            color: #333333;
          }
        }
        &_b {
          display: flex;
          column-gap: 10px;
          span {
            font-size: 14px;
            color: #666666;
          }
        }
      }
      &_empty {
        flex: 1;
        min-height: 260px;
        background: #f7f7f7;
        border-radius: 6px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        color: #999999;
        .empty_icon {
          width: 42px;
          height: 42px;
          border-radius: 50%;
          background: #ffa71d;
          color: #ffffff;
          font-size: 26px;
          font-weight: bold;
          line-height: 42px;
          text-align: center;
          margin-bottom: 14px;
        }
        .empty_title {
          color: #333333;
          font-size: 18px;
          font-weight: bold;
          margin-bottom: 8px;
        }
        .empty_desc {
          font-size: 13px;
        }
      }
    }
  }
}
</style>
